import { get } from "@/services/axiosUitils";

const basePath = "/city_collab/organizations";

class OrganizationService {
  /**
   * Get all organizations
   */
  getAllOrganizations = async ({
    page,
    pageSize,
  }: {
    page: number;
    pageSize: number;
  }): Promise<any> => {
    const response = await get<any>(`${basePath}/`, {
      params: {
        page,
        page_size: pageSize,
      },
    });

    // Handle the nested response structure
    if (response?.results?.data) {
      return {
        count: response.count,
        next: response.next,
        previous: response.previous,
        results: response.results.data,
      };
    }

    // Fallback for different response structures
    return {
      count: response.count ?? 0,
      next: response.next ?? null,
      previous: response.previous ?? null,
      results: response.results ?? response.data ?? [],
    };
  };

  /**
   * Get organization by ID
   */
  getOrganizationById = async (id: string): Promise<any> => {
    if (!id) {
      throw new Error("Organization ID is required");
    }
    return await get<any>(`${basePath}/${id}/`);
  };
}

export default new OrganizationService();
